import { getWebInstrumentations, initializeFaro } from '@grafana/faro-web-sdk';
import { TracingInstrumentation } from '@grafana/faro-web-tracing';

let initialized = false;

export function initFaro() {
  if (typeof window === 'undefined' || initialized) {
    return;
  }

  // Only skip in dev; use Faro in all other cases (production, staging, etc.)
  if (process.env.NODE_ENV === 'development') {
    return;
  }

  initialized = true;

  try {
    initializeFaro({
      url: process.env.NEXT_PUBLIC_FARO_COLLECTOR_URL ?? '',
      app: {
        name: process.env.NEXT_PUBLIC_FARO_APP_NAME ?? 'platform-frontend',
        version: process.env.NEXT_PUBLIC_FARO_APP_VERSION ?? '0.0.0',
        environment: process.env.NEXT_PUBLIC_FARO_ENVIRONMENT ?? 'production',
      },
      sessionTracking: {
        samplingRate: 1,
        persistent: true,
      },
      instrumentations: [
        ...getWebInstrumentations(),
        new TracingInstrumentation(),
      ],
    });
  } catch (err) {
    console.warn('[Faro] Initialization failed:', err);
  }
}